<div *ngIf="!goToCivitek && !goToFortPoint">
  <div class="form-display-card">
    <mat-card class='mat-card-display mb-3'>
      <mat-card-header>
        <mat-card-title class="justify-content-center">
          <h2 class="mat-card-title align-items-start">
            <span class="fa fa-credit-card fa-md-black dib mr-2"></span> Review Credit
            Card Payment Information
          </h2>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <table class="table">
          <thead>
            <tr>
              <th *ngFor="let col of paymentheader">{{col}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{creditCardPayment.firstName}}</td>
              <td>{{creditCardPayment.lastName}}</td>
              <td>{{ maskSSN(creditCardPayment.ssn) }}</td>
              <td *ngIf="ncpUseCaseNumberForPayment">{{creditCardPayment.secondaryId}}</td>
              <td>{{creditCardPayment.amount | currency}}</td>
            </tr>
          </tbody>
        </table>
        <div class="col mb-3">
          <div class="account-details-sum">
            <div *ngIf="showFees" class="account-sum-row">
              <div class="account-dt">Payment Amount</div>
              <div class="account-dt-info">{{creditCardPayment.amount | currency}}</div>
            </div>
            <div *ngIf="showFees" class="account-sum-row">
              <div class="account-dt">Service Fee %</div>
              <div class="account-dt-info">{{creditCardPayment.feePercentage | percent: '.2'}}</div>
            </div>
            <div *ngIf="showFees" class="account-sum-row">
              <div class="account-dt">Service Fee Amount</div>
              <div class="account-dt-info">{{serviceFeeAmount | currency}}</div>
            </div>
            <div *ngIf="showFees" class="account-sum-row">
              <div class="account-dt">Total Credit Card Amount</div>
              <div class="account-dt-info">{{totalCreditCardAmount | currency}}</div>
            </div>
            <div *ngIf="!showFees" class="account-sum-row">
              <div class="account-dt">Total Credit Card Amount</div>
              <div class="account-dt-info">{{creditCardPayment.amount | currency}}</div>
            </div>
          </div>
        </div>
        <div class="pt-2 pb-2">
          <div class="c-red1 ts-s" [innerHTML]="creditCardDisclaimer"></div>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="flex-btn-row pt-2 pb-2">
      <button class="btn btn-secondary" mat-button matStepperPrevious>Back</button>
      <button class="btn btn-primary-short" [disabled]="disableCreatePaymentButton"
        (click)="navigateWithPayment()">
        {{ createPaymentButtonText }}
      </button>
    </div>
  </div>
</div>
